interface DataTablePopupCard {
  title: string;
  value: number | string;
}
const DataTablePopupCard = ({ title, value }: DataTablePopupCard) => {
  return (
    <div className="bg-gray-2500 rounded-lg shadow p-3">
      <div className="text-ds-gray-500 text-xs">{title ?? '-'}</div>
      <div className="mt-2  font-semibold text-ds-gray-700">{value ?? '-'}</div>
    </div>
  );
};

export default DataTablePopupCard;
